import { createSlice } from '@reduxjs/toolkit';
import { makeRequest } from '../components/utils';

const prefixes = {
    tipo_identificacion: 'type/identification',
    tipo_persona: 'type/person',
    tipo_propiedad: 'type/ownership',
    tipo_proveedor: 'type/supplier',
    tipo_categoria: 'type/category',
    tipo_estado: 'type/state',
    tipo_pago: 'type/',
    conjunto: "condo",
    propiedad: "ownership",
    modulo: 'module'
};

export async function fetchModuleOptionList(module, filters) {
    return await makeRequest(`${prefixes[module] || module}/OptionList`, 'post', { ...filters });
}

export async function fetchModuleAutocomplete(module, value, filters) {
    return await makeRequest(`${prefixes[module] || module}/Autocomplete`, 'post', { ...filters, value });
}

export async function fetchLogin({ username, password }) {
    return await makeRequest(`login/signin`, 'post', { username, password });
}

export const commonsSlice = createSlice({
    name: 'common',

    initialState: {
        currentMenuAction: 'dashboard',
        logguedUserData: null,
        isLoading: false,
    },
    reducers: {
        setCurrentMenuAction: (state, action) => {
            state.currentMenuAction = action.payload;
        },
        setLogguedUserData: (state, action) => {
            if (action.payload) {
                state.logguedUserData = { ...action.payload, selConjunto: action.payload.conjuntos?.length > 0 ? action.payload.conjuntos[0] : null };
            } else {
                state.logguedUserData = null;
            }
        },
        setSelectedConjunto: (state, action) => {
            state.logguedUserData = { ...state.logguedUserData, selConjunto: action.payload };
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        }
    }
})

export const {
    setCurrentMenuAction,
    setLogguedUserData,
    setSelectedConjunto,
    setIsLoading
} = commonsSlice.actions;

export default commonsSlice.reducer
